// @flow
import {
  buildMultipleDataFetcher,
  buildSingleDataFetcher,
} from 'app/general/datafetchers/builders';
import {getDenormalizedListFactory} from 'app/utils/redux_v2';

import {convertLocationParamsToFetchParams} from './api';
import {fetchPolicies} from 'app/policies/actions';
import type {PolicyType} from 'app/policies/types';

export const denormalizePoliciesList = getDenormalizedListFactory<PolicyType>(
  (state) => state.policiesArea
);

export const MultipleStoredPoliciesFetcher =
  buildMultipleDataFetcher<PolicyType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchPolicies,
    denormalizePoliciesList
  );

export const StoredPoliciesFetcher = buildSingleDataFetcher<PolicyType>(
  MultipleStoredPoliciesFetcher
);
